import { Component } from '@angular/core';

@Component({
  selector: 'app-offline-page',
  templateUrl: './offline-page.component.html',
  styleUrls: ['./offline-page.component.scss']
})
export class OfflinePageComponent {
  isOnline: boolean = navigator.onLine; // Inicializa com o estado atual da conexão

  ngOnInit() {
    // Listener para detectar mudanças de conexão
    window.addEventListener('online', () => {
      this.isOnline = true; // Atualiza o estado quando online
    });

    window.addEventListener('offline', () => {
      this.isOnline = false; // Atualiza o estado quando offline
    });
  }

}
